// extracted by mini-css-extract-plugin
export default {"tableWrapper":"MerchantShopOverview_tableWrapper__SkWSu","buttonBar":"MerchantShopOverview_buttonBar__TXaxN"};